export default "/images/vendor/flag-icon-css/flags/4x3/sg.svg?e6a27ad3fc2dedabca8b680fae357537";